import { lightTokens, hexToRgbTriplet, type TokenMap } from './tokens'

export { lightTokens, hexToRgbTriplet }
export type { TokenMap }

function renderVars(tokens: TokenMap, indent = '  '): string {
  return Object.entries(tokens)
    .map(([k, v]) => `${indent}--${k}: ${v};`)
    .join('\n')
}

export interface BrandingOverrides {
  /** Hex-Wert, z. B. "#2B87C7" */
  accentColor?: string | null
  accentHoverColor?: string | null
}

function applyOverrides(base: TokenMap, o?: BrandingOverrides): TokenMap {
  if (!o) return base
  const next = { ...base }
  const accent = o.accentColor ? hexToRgbTriplet(o.accentColor) : null
  if (accent) next['color-accent'] = accent
  const hover = o.accentHoverColor ? hexToRgbTriplet(o.accentHoverColor) : null
  if (hover) next['color-accent-hover'] = hover
  return next
}

/**
 * Vollständiges Theme-CSS erzeugen (helles Theme, kein dunkler Modus).
 * Mit `overrides` werden mandantenspezifische Werte (z. B. Akzentfarbe)
 * eingesetzt — zur Build- oder Laufzeit.
 */
export function buildThemeCss(overrides?: BrandingOverrides): string {
  const light = applyOverrides(lightTokens, overrides)
  return [':root {', renderVars(light), '}', ''].join('\n')
}

/**
 * Nur die überschriebenen Variablen als Inline-Deklarationen — geeignet,
 * um sie zur Laufzeit auf <html> zu setzen (mandantenspezifisches Branding).
 */
export function brandingCssVars(overrides: BrandingOverrides): Record<string, string> {
  const out: Record<string, string> = {}
  const accent = overrides.accentColor ? hexToRgbTriplet(overrides.accentColor) : null
  if (accent) out['--color-accent'] = accent
  const hover = overrides.accentHoverColor ? hexToRgbTriplet(overrides.accentHoverColor) : null
  if (hover) out['--color-accent-hover'] = hover
  return out
}
